import { getArtDepositoPanel } from "../../services/ArticulosDepositoServices";
import { ArticulosDepositoContext } from "./ArticulosDepositoContext"
import { getArticulosExistenciaPanel} from "../../services/ArticulosServices";

export const ArticulosDepositoState = ({ children }) => {
    const getArtDepositoPanelData = async (searchRam, searchTerm, page, perPage) => {
        let res = await getArtDepositoPanel(searchRam, searchTerm, page, perPage)
        return res;
    }
    const getArticulosExistenciaPanelData = async (searchTerm, searchIDDepo, searchIDRam, searchIDRub, searchIDSubr, searchIDMar, searchDes,searchStock, page, perPage,selectOrderBy,selectOrder) => {
        let res = await getArticulosExistenciaPanel(searchTerm, searchIDDepo, searchIDRam, searchIDRub, searchIDSubr, searchIDMar, searchDes, searchStock, page, perPage, selectOrderBy, selectOrder)
        return res;
    }
    return <ArticulosDepositoContext.Provider value={{
        getArtDepositoPanelData,getArticulosExistenciaPanelData
    }} >
        {children}
    </ArticulosDepositoContext.Provider>
}